import { useEffect, useState } from 'react';

export function useTerms() {
  const [term, setTerm] = useState<string | undefined>();
  const [customTerm, setCustomTerm] = useState<string | undefined>();

  const loadTerm = async (url: string) => {
    const response = await fetch(url);

    if (response.status === 200) {
      const text = await response.text();

      return text;
    }
  };

  const loadTerms = async () => {
    const term = await loadTerm(
      'https://plugone-production.nyc3.digitaloceanspaces.com/terms-and-conditions/terms-and-conditions.html',
    );

    const customTerm = await loadTerm(
      `https://plugone-production.nyc3.digitaloceanspaces.com/terms-and-conditions/${window.location.hostname}.html`,
    );

    if (term) setTerm(term);
    if (customTerm) setCustomTerm(customTerm);
  };

  useEffect(() => {
    loadTerms();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    customTerm,
    term,
  };
}
